import { compose } from 'recompose';
import ServiceDetail from './Detail';
import apiInterceptor from '../../../../api/interceptor';
import { skuDetailsApi, buApi } from '../../../common/base.api';

const composedServiceDetail = compose(apiInterceptor({ ...skuDetailsApi, getBUList: buApi.getList }))(ServiceDetail);

export default composedServiceDetail;
